// University of Iowa's undergraduate majors (#2748). Read on 2026-10-01
// from the official 2026-27 General Catalog's "Your Program" index
// (catalog.registrar.uiowa.edu/your-program/), which lists every program
// with its level and degree. Kept: every Undergraduate entry tagged as a
// bachelor's degree (including the catalog's "Other Bachelor's Degrees":
// BFA, BM, BSN, BAS and BLS). Minors, certificates, graduate and
// professional programs are left out. Each program is grouped under the
// college whose catalog section it sits in (the link path), and names and
// degree abbreviations are the catalog's own (BA, BS, BBA, BSE, ...). The
// BAS and BLS are University College degrees. The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "university-of-iowa",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Iowa's official 2026-27 General Catalog, grouped by the college that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Liberal Arts and Sciences",
            "source": {
                "label": "University of Iowa 2026-27 General Catalog, Your Program",
                "url": "https://catalog.registrar.uiowa.edu/your-program/"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "BS"
                },
                {
                    "name": "Ancient Civilization",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Asian Languages and Literature",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Cinema",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminology, Law, and Justice",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "English and Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Enterprise Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Policy and Planning",
                    "degree": "BA"
                },
                {
                    "name": "Ethics and Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geographical and Sustainability Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Geographical and Sustainability Sciences",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Global Health Studies",
                    "degree": "BA"
                },
                {
                    "name": "Global Health Studies",
                    "degree": "BS"
                },
                {
                    "name": "Health Promotion",
                    "degree": "BS"
                },
                {
                    "name": "Health Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Physiology",
                    "degree": "BS"
                },
                {
                    "name": "Informatics",
                    "degree": "BA"
                },
                {
                    "name": "Informatics",
                    "degree": "BS"
                },
                {
                    "name": "Interdepartmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BS"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism and Mass Communication",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Screenwriting Arts",
                    "degree": "BA"
                },
                {
                    "name": "Social Work",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Speech and Hearing Science",
                    "degree": "BA"
                },
                {
                    "name": "Sport Media and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Sport and Recreation Management",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                },
                {
                    "name": "Therapeutic Recreation",
                    "degree": "BS"
                },
                {
                    "name": "Translation",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Tippie College of Business",
            "source": {
                "label": "University of Iowa 2026-27 General Catalog, Your Program",
                "url": "https://catalog.registrar.uiowa.edu/your-program/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Analytics and Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BBA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "University of Iowa 2026-27 General Catalog, Your Program",
                "url": "https://catalog.registrar.uiowa.edu/your-program/"
            },
            "majors": [
                {
                    "name": "Bachelor of Science in Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSE"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "University of Iowa 2026-27 General Catalog, Your Program",
                "url": "https://catalog.registrar.uiowa.edu/your-program/"
            },
            "majors": [
                {
                    "name": "Bachelor of Science in Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "University of Iowa 2026-27 General Catalog, Your Program",
                "url": "https://catalog.registrar.uiowa.edu/your-program/"
            },
            "majors": [
                {
                    "name": "Art Education",
                    "degree": "BA"
                },
                {
                    "name": "Counseling and Behavioral Health Services",
                    "degree": "BA"
                },
                {
                    "name": "Education Studies and Human Relations",
                    "degree": "BA"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "English Education",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics Education",
                    "degree": "BA"
                },
                {
                    "name": "Music Education",
                    "degree": "BA"
                },
                {
                    "name": "Science Education",
                    "degree": "BA"
                },
                {
                    "name": "Science Studies",
                    "degree": "BS"
                },
                {
                    "name": "Social Studies Education",
                    "degree": "BA"
                },
                {
                    "name": "Special Education",
                    "degree": "BA"
                },
                {
                    "name": "World Language Education",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Public Health",
            "source": {
                "label": "University of Iowa 2026-27 General Catalog, Your Program",
                "url": "https://catalog.registrar.uiowa.edu/your-program/"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "BA"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Carver College of Medicine",
            "source": {
                "label": "University of Iowa 2026-27 General Catalog, Your Program",
                "url": "https://catalog.registrar.uiowa.edu/your-program/"
            },
            "majors": [
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear Medicine Technology",
                    "degree": "BS"
                },
                {
                    "name": "Radiation Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "University College",
            "source": {
                "label": "University of Iowa 2026-27 General Catalog, Your Program",
                "url": "https://catalog.registrar.uiowa.edu/your-program/"
            },
            "majors": [
                {
                    "name": "Bachelor of Applied Studies",
                    "degree": "BAS"
                },
                {
                    "name": "Bachelor of Liberal Studies",
                    "degree": "BLS"
                }
            ]
        }
    ]
};

export default majors;
